module.exports = __webpack_public_path__ + "static/media/insect(20).52328e09.PNG";